<script lang="ts">
    import type {PublicStatsData} from '../../types';
    import {getLocalization} from 'core/svelte-context/context';
    import KpStatsNumberInfoBox from '../../components/KpStatsNumberInfoBox.svelte';
    import KpStatsInfoGrid from '../../components/KpStatsInfoGrid.svelte';
    import KpTitledSection from 'shared/layouts/containers/KpTitledSection.svelte';

    export let statsData: PublicStatsData;
    const localize = getLocalization();

    $: fondsInfo = statsData.stats.result.documentsAndExemplarsCountsByFonds.counts;
    $: isEmpty = fondsInfo.length === 0;
</script>

{#if !isEmpty}
    <KpTitledSection additionalClasses="stats-fonds-info"
                     title="{localize(/* @kp-localization statistiky.statistikyFondu */ 'statistiky.statistikyFondu')}"
                     headingType="h3">

        <KpStatsInfoGrid>
            {#each fondsInfo as documentsAndExemplarsCountByFond}
                <KpStatsNumberInfoBox boxType="default">
                    <div class="fond-stat-container">
                        <span class="value-label">{documentsAndExemplarsCountByFond.name}</span>

                        <span class="value">
                            {localize(/* @kp-localization commons.Documents */ 'commons.Documents')}: {documentsAndExemplarsCountByFond.value.first}
                         </span>

                        <span class="value">
                            {localize(/* @kp-localization commons.Exemplare */ 'commons.Exemplare')}: {documentsAndExemplarsCountByFond.value.second}
                        </span>
                    </div>
                </KpStatsNumberInfoBox>
            {/each}
        </KpStatsInfoGrid>
    </KpTitledSection>
{/if}

<style lang="less">
    @import (reference) "styles/portaro.variables.less";

    .fond-stat-container {
        display: flex;
        flex-direction: column;
        gap: @spacing-s;
        align-items: center;

        .value-label {
            font-size: @font-size-large;
            font-weight: 500;
        }

        .value {
            opacity: 0.75;
        }
    }
</style>